<template>
    <div class="item" :class="{'new': coupon.isNew || false, 'used': coupon.used_at || false, 'expired': isExpired}" @click.stop="isShow = !isShow">
        <div class="title">{{ coupon.title }}</div>
        <div class="content">
            {{ coupon.content || '沒有使用說明' }}
        </div>
        <div class="info">
            <div class="left">
                <img src="@/assets/img/more-green-up.svg" v-show="isShow">
                <img src="@/assets/img/more-green-down.svg" v-show="!isShow">
                <span>{{ coupon.last }}</span>
            </div>
            <div class="right">
                $ {{ coupon.value }}
            </div>
        </div>
        <div class="terms" v-show="isShow">
            <pre>{{ coupon.terms || '沒有條款說明' }}</pre>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CouponItem',
        props: {
            coupon: {
                required: true,
            },
            isExpired: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                isShow: false,
            }
        }
    };
</script>

<style lang="scss" scoped>
    .item {
        cursor: pointer;
        margin: 10px 0;
        text-align: left;
        border: 1px solid #DDDDDD;
        border-radius: 5px;
        background-color: #FFFFFF;
        padding: 10px;
        position: relative;

        &.new {
            border: 1px solid #339933;

            &::before{
                content: 'New !';
                border-radius: 100px 0 0 100px;
                background-color: #339933;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 500;
                position: absolute;
                right: 0;
                padding: 0 10px 0 15px;
            }
        }

        &.used, &.expired {
            color: #9b9b9b;
            background-color: #fafafa;
            border: none;

            .title {
                color: #9b9b9b;
            }

            .content {
                color: #9b9b9b;
            }

            .info {
                .right {
                    color: #9b9b9b;
                }
            }
        }

        &.used {
            &::before{
                content: '已使用';
                border-radius: 100px 0 0 100px;
                background-color: #CCCCCC;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 500;
                position: absolute;
                right: 0;
                padding: 0 10px 0 15px;
            }
        }

        .title {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
        }

        .content {
            margin-top: 5px;
            color: #000000;
            font-size: 12px;
            line-height: 17px;
        }

        .info {
            margin-top: 10px;
            color: #9B9B9B;
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;

        .left {
            display: flex;
            align-items: center;
        }

        .right {
            color: #339933;
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            text-align: right;
        }

        img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }
        }

        .terms {
            margin-top: 10px;
            color: #9B9B9B;
            font-size: 12px;
            line-height: 17px;
            border-top: solid 1px #DDDDDD;
        }
    }

    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>
